module.exports = __webpack_public_path__ + "img/obs_rain_missing.eb4e090a.svg";